/*
  this files poluate data in dedux state
*/
import axios from 'axios'
import CONFIG from '../config.json'
import { populate, update, updateVolumenPaez } from './typeMessages'

export const populateHttp = (store) => {
  let init = Date.now() // + 60 * 60 * 5
  let end = (date, n) => date - 1000 * 60 * 60 * 24 * n

  const requests = [
    ['valledetenza', 'mean5M_pressure', 'pressure', init, end(init, 31), null, 'mean', 'last_month'],
    ['valledetenza', 'mean5M_cfpressure', 'cfpressure', init, end(init, 31), null, 'mean', 'last_month'],
    ['valledetenza', 'mean5M_cfflow', 'cfflow', init, end(init, 31), null, 'mean', 'last_month'],
    ['valledetenza', 'mean5M_temperature', 'temperature', init, end(init, 31), null, 'mean', 'last_month'],
    ['valledetenza', 'cfvolumen_total_day', 'cfvolumen_total_day', init, end(init, 31), '1d', 'last', null],

    ['mochileros', 'mean5M_pressure', 'pressure', init, end(init, 31), null, 'mean', 'last_month'],
    ['mochileros', 'mean5M_cfpressure', 'cfpressure', init, end(init, 31), null, 'mean', 'last_month'],
    ['mochileros', 'mean5M_cfflow', 'cfflow', init, end(init, 31), null, 'mean', 'last_month'],
    ['mochileros', 'mean5M_temperature', 'temperature', init, end(init, 31), null, 'mean', 'last_month'],
    ['mochileros', 'cfvolumen_total_day', 'cfvolumen_total_day', init, end(init, 31), '1d', 'last', null],

    ['paez', 'mean5M_pressure', 'pressure', init, end(init, 31), null, 'mean', 'last_month'],
    ['paez', 'volumen_cal', 'volumen_total_day', init, end(init, 31), '1d', 'sum', null],
    ['paez', 'volumen_cal', 'volumen_total_hour', init, end(init, 31), '1h', 'sum', null],

    ['umbita', 'mean5M_pressure', 'pressure', init, end(init, 31), null, 'mean', 'last_month'],
    ['umbita', 'mean5M_pressure2', 'pressure2', init, end(init, 31), null, 'mean', 'last_month'],
    ['umbita', 'mean5M_pressure3', 'pressure3', init, end(init, 31), null, 'mean', 'last_month'],
    ['umbita', 'mean5M_temperature', 'temperature', init, end(init, 31), null, 'mean', 'last_month'],
    ['umbita', 'flow_rate', 'pulsos', init, end(init, 31), null, 'mean', 'last_month'],
    ['umbita', 'pulsos', 'acumulate_pulsos', init, 1645467600000, '1d', 'sum', 'autogen'],
  ]

  requests.map(req => {
    return axios.get(`${CONFIG.httpUrl}/api/${req[0]}/${req[1]}/${req[6]}`, {
      json: true,
      params: {
        init: req[3],
        end: req[4],
        interval: req[5] || '5m',
        policy: req[7]
      }
    }).then(payload => {
      payload.data.name = req[2]
      store.dispatch(populate(payload.data))
    }).catch(err => {
      console.error(err)
    })
  })
}

export const updateHttp = (store) => {
  const requests = [
    ['valledetenza', 'pressure', 'last_month'],
    ['valledetenza', 'cfpressure', 'last_month'],
    ['valledetenza', 'cfflow', 'last_month'],
    ['valledetenza', 'temperature', 'last_month'],

    ['miraflores', 'pressure', 'last_month'],
    ['miraflores', 'cfpressure', 'last_month'],
    ['miraflores', 'cfflow', 'last_month'],
    ['miraflores', 'temperature', 'last_month'],

    ['mochileros', 'pressure', 'last_month'],
    ['mochileros', 'cfpressure', 'last_month'],
    ['mochileros', 'cfflow', 'last_month'],
    ['mochileros', 'temperature', 'last_month'],

    ['paez', 'pressure', 'last_month'],

    ['umbita', 'pressure','last_month'],
    ['umbita', 'pressure2', 'last_month'],
    ['umbita', 'temperature', 'last_month'],
    ['umbita', 'pressure3', 'last_month'],
  ]

  setInterval(() => {
    let init = Date.now()
    let end = init - 1000 * 60 * 20

    requests.map(req => {
      return axios.get(`${CONFIG.httpUrl}/api/${req[0]}/${req[1]}/mean`, {
        json: true,
        params: {
          init,
          end,
          policy: req[3]
        }
      }).then(payload => {
        store.dispatch(update(payload.data))
      }).catch(err => console.error(`${CONFIG.httpUrl}/api/${req[0]}/${req[1]}`, init, end, err))
    })
  }, 1000 * 60 * 5)
}

export const updateHttpVolumen = (store) => {
  const requests = [
    ['paez', 'volumen_cal', 'volumen_total_day', null]
  ]

  let init = Date.now()
  let end = init - 1000 * 60 * 60 * 24 * 1

  requests.map(req => {
    return axios.get(`${CONFIG.httpUrl}/api/${req[0]}/${req[1]}/sum`, {
      json: true,
      params: {
        init,
        end,
        interval: '1d',
        policy: req[3]
      }
    }).then(payload => {
      payload.data.name = req[2]
      store.dispatch(
        updateVolumenPaez(payload.data)
      )
    }).catch(err => console.error(`${CONFIG.httpUrl}/api/${req[0]}/${req[1]}`, init, end, err))
  })

  setInterval(() => {
    let init = Date.now()
    let end = init - 1000 * 60 * 60 * 24 * 1

    requests.map(req => {
      return axios.get(`${CONFIG.httpUrl}/api/${req[0]}/${req[1]}/sum`, {
        json: true,
        params: {
          init,
          end,
          interval: '1d',
          policy: req[3]
        }
      }).then(payload => {
        payload.data.name = req[2]
        store.dispatch(
          updateVolumenPaez(payload.data)
        )
      }).catch(err => console.error(`${CONFIG.httpUrl}/api/${req[0]}/${req[1]}`, init, end, err))
    })
  }, 1000 * 60 * 5)
}



// WEBPACK FOOTER //
// ./src/store/populate.js